import { proxy } from 'valtio';

export const upsellState = proxy({
	show: false,
});
